import { trackClientEvent } from 'analytics/analytics'

const CATEGORY = 'chat_trip_planner'

export type EntryPointType =
  | 'typed_prompt'
  | 'recent_search_card'
  | 'booking_card'
  | 'suggestion_chip'
  | 'recent_trip_card'
  | 'viewed_offer_card'

function chatSubject(descriptor: string, chatId: number | undefined): string {
  return chatId !== undefined ? `${descriptor}_${chatId}` : descriptor
}

export function trackSessionStart(
  chatId: number | undefined,
  sessionType: 'new' | 'returning',
) {
  trackClientEvent({
    subject: chatSubject(`session_${sessionType}`, chatId),
    action: 'session_start',
    category: CATEGORY,
    type: 'nonInteraction',
  })
}

export function trackEntryPoint(entryType: EntryPointType) {
  trackClientEvent({
    subject: `entry_${entryType}`,
    action: 'entry_point_selected',
    category: CATEGORY,
    type: 'interaction',
  })
}

export function trackFirstMessageSent(chatId: number, timeToFirstMessageMs: number) {
  trackClientEvent({
    subject: chatSubject(`first_message_${Math.round(timeToFirstMessageMs)}ms`, chatId),
    action: 'first_message_sent',
    category: CATEGORY,
    type: 'interaction',
  })
}

export function trackHotelDrawerOpened(chatId: number) {
  trackClientEvent({
    subject: chatSubject('hotel_drawer', chatId),
    action: 'hotel_drawer_opened',
    category: CATEGORY,
    type: 'interaction',
  })
}

export function trackExperienceDrawerOpened(chatId: number) {
  trackClientEvent({
    subject: chatSubject('experience_drawer', chatId),
    action: 'experience_drawer_opened',
    category: CATEGORY,
    type: 'interaction',
  })
}

export function trackCruiseDrawerOpened(chatId: number) {
  trackClientEvent({
    subject: chatSubject('cruise_drawer', chatId),
    action: 'cruise_drawer_opened',
    category: CATEGORY,
    type: 'interaction',
  })
}

export function trackVoiceInputUsed(chatId: number | undefined) {
  trackClientEvent({
    subject: chatSubject('voice_input', chatId),
    action: 'voice_input_used',
    category: CATEGORY,
    type: 'interaction',
  })
}

export function trackMapPinClicked(chatId: number, offerId: string) {
  trackClientEvent({
    subject: chatSubject(`map_pin_${offerId}`, chatId),
    action: 'map_pin_clicked',
    category: CATEGORY,
    type: 'interaction',
  })
}

export function trackViewModeToggled(chatId: number, newMode: 'detail' | 'compact') {
  trackClientEvent({
    subject: chatSubject(`view_mode_${newMode}`, chatId),
    action: 'view_mode_toggled',
    category: CATEGORY,
    type: 'interaction',
  })
}

export function trackCarouselPaginated(chatId: number | undefined) {
  trackClientEvent({
    subject: chatSubject('carousel', chatId),
    action: 'carousel_paginated',
    category: CATEGORY,
    type: 'interaction',
  })
}

export function trackSessionEnd(chatId: number | undefined, durationMs: number) {
  trackClientEvent({
    subject: chatSubject(`session_end_${Math.round(durationMs)}ms`, chatId),
    action: 'session_end',
    category: CATEGORY,
    type: 'nonInteraction',
  })
}
